module.exports = __webpack_public_path__ + "d71a5580a22345b14e3c4253d0fc73dc.png";